"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var Card = function Card(props) {
  var alias = props.alias,
      elementChar = props.elementChar,
      modifierChar = props.modifierChar,
      className = props.className,
      variant = props.variant,
      header = props.header,
      body = props.body,
      footer = props.footer,
      other = (0, _objectWithoutPropertiesLoose2.default)(props, ["alias", "elementChar", "modifierChar", "className", "variant", "header", "body", "footer"]);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: (alias + " " + alias + modifierChar + variant + " " + className).trim()
  }, other), /*#__PURE__*/_react.default.createElement("div", {
    className: "" + alias + elementChar + "inner"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "" + alias + elementChar + "header"
  }, header), /*#__PURE__*/_react.default.createElement("div", {
    className: "" + alias + elementChar + "body"
  }, body), /*#__PURE__*/_react.default.createElement("div", {
    className: "" + alias + elementChar + "footer"
  }, footer)));
};

Card.propTypes = {
  alias: _propTypes.default.string,
  elementChar: _propTypes.default.string,
  modifierChar: _propTypes.default.string,
  className: _propTypes.default.string,
  variant: _propTypes.default.string,
  header: _propTypes.default.node,
  body: _propTypes.default.node,
  footer: _propTypes.default.node
};
Card.defaultProps = {
  alias: 'Card',
  elementChar: '_',
  modifierChar: '___',
  className: ''
};
Card.displayName = 'Card';
var _default = Card;
exports.default = _default;